/**
 * Project Saga
 */
/* tslint:disable:space-before-function-paren */

import { sagaAsyncActionWorkerFactory } from '../../utils/saga';
import { pushNotification } from '../actions/notifications';
import * as actions from '../actions/projects';
import { addTrackToProject, createProject, deleteProject, joinProject, updateProject } from '../helpers/projects';
import { getViewerId } from '../selectors/user';

import { effects as fx } from 'redux-saga';
import { Action } from 'typescript-fsa';

type CreateProjectRequestAction = Action<IRequestCreateProjectActionPayload>;
type UpdateProjectRequestAction = Action<IRequestUpdateProjectActionPayload>;
type JoinProjectRequestAction = Action<IRequestJoinProjectActionPayload>;
type DeleteProjectRequestAction = Action<IRequestDeleteProjectActionPayload>;
type AddTrackToProjectRequestAction = Action<IRequestAddTrackToProjectActionPayload>;

export function* init() {
  yield fx.all([
    fx.call(watchForCreateProject),
    fx.call(watchForUpdateProject),
    fx.call(watchForDeleteProject),
    fx.call(watchForAddTrackToProject),
    fx.call(watchForJoinProject),
  ]);
}

function* watchForCreateProject() {
  while (true) {
    const { payload: { input, promise } }: CreateProjectRequestAction = yield fx.take(actions.requestCreateProject);
    const viewerId = yield fx.select(getViewerId);
    try {
      const worker = sagaAsyncActionWorkerFactory<ICreateProjectActionPayload>(
        actions.createProject,
        createProject,
      );
      const { response, errors } = yield fx.call(worker, { input }, viewerId);
      if (errors) {
        promise.reject(errors);
      } else {
        promise.resolve(response);
      }
    } catch (error) {
      promise.reject(error);
    }
  }
}

function* watchForUpdateProject() {
  while (true) {
    const { payload }: UpdateProjectRequestAction = yield fx.take(actions.requestUpdateProject);
    try {
      const worker = sagaAsyncActionWorkerFactory<IUpdateProjectActionPayload>(
        actions.updateProject,
        updateProject,
      );
      const { response, errors } = yield fx.call(worker, payload);
      if (errors) {
        payload.promise.reject(errors);
      } else {
        payload.promise.resolve(response);
      }
    } catch (error) {
      payload.promise.reject(error);
    }
  }
}

function* watchForDeleteProject() {
  while (true) {
    const { payload }: DeleteProjectRequestAction = yield fx.take(actions.requestDeleteProject);
    const viewerId = yield fx.select(getViewerId);
    try {
      const worker = sagaAsyncActionWorkerFactory<IDeleteProjectActionPayload>(
        actions.deleteProject,
        deleteProject,
      );
      const { response, errors } = yield fx.call(worker, payload, viewerId);
      if (errors) {
        payload.promise.reject(errors);
      } else {
        payload.promise.resolve(response);
      }
    } catch (error) {
      payload.promise.reject(error);
    }
  }
}

function* watchForJoinProject() {
  while (true) {
    const { payload }: JoinProjectRequestAction = yield fx.take(actions.requestJoinProject);
    try {
      const worker = sagaAsyncActionWorkerFactory<IJoinProjectActionPayload>(
        actions.joinProject,
        joinProject,
      );

      const { response, errors }: IMutationResult = yield fx.call(worker, payload);

      if (errors) {
        yield fx.put(pushNotification({
          autoDismiss: false,
          state: 'error',
          message: `Something went wrong: ${JSON.stringify(errors)}`,
        }));
        payload.promise.reject(errors);
      } else {
        const projectName = response!.joinProject!.project!.name;
        yield fx.put(pushNotification({
          state: 'success',
          message: `Congratulations! You are now a collaborator on playlist ${projectName}.`,
        }));
        payload.promise.resolve(response);
      }
    } catch (error) {
      yield fx.put(pushNotification({
        autoDismiss: false,
        state: 'error',
        message: `Something went wrong: ${error}`,
      }));
      payload.promise.reject(error);
    }
  }
}

function* watchForAddTrackToProject() {
  while (true) {
    const { payload }: AddTrackToProjectRequestAction = yield fx.take(actions.requestAddTrackToProject);
    try {
      const worker = sagaAsyncActionWorkerFactory<IAddTrackToProjectActionPayload>(
        actions.addTrackToProject,
        addTrackToProject,
      );
      const { response, errors } = yield fx.call(worker, payload);
      if (errors) {
        payload.promise.reject(errors);
      } else {
        payload.promise.resolve(response);
      }
    } catch (error) {
      payload.promise.reject(error);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/sagas/projects.ts